import { Button } from "../components/ui/button";
import { Star } from "lucide-react";

const GOOGLE_REVIEW_URL = "https://g.page/r/CRqHivwdcCHlEBM/review";

const Reviews = () => {
  return (
    <section className="py-20 px-8" data-testid="reviews-section">
      <div className="max-w-2xl mx-auto text-center">
        <h2
          className="text-3xl md:text-4xl font-bold mb-8"
          style={{ color: "#1A2118" }}
          data-testid="reviews-heading"
        >
          Priecāsimies saņemt atsauksmi!
        </h2>

        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-review-link"
        >
          <Button
            data-testid="google-review-button"
            className="text-white text-base px-8 py-7 rounded-full font-bold shadow-lg hover:scale-105 transition-transform duration-200"
            style={{ backgroundColor: "#27A64C" }}
          >
            <Star className="mr-2 h-5 w-5" style={{ fill: "white" }} />
            Atstāt atsauksmi Google
          </Button>
        </a>
      </div>
    </section>
  );
};

export default Reviews;
